export var PageType;

(function (PageType) {
  PageType["FullPage"] = "FULL_PAGE";
  PageType["ESI"] = "ESI";
  PageType["UndefinedPage"] = "UNDEFINED_PAGE";
})(PageType || (PageType = {}));